export const headers = [
  {
    text: 'ID',
    align: 'start',
    sortable: true,
    value: 'id',
  },
  {
    text: 'Nome',
    align: 'start',
    sortable: true,
    value: 'name',
  },
  {
    text: 'Latitude',
    align: 'start',
    sortable: true,
    value: 'latitude',
  },
  {
    text: 'Longitude',
    align: 'start',
    sortable: true,
    value: 'longitude',
  },
  {
    text: 'Cor',
    align: 'start',
    sortable: true,
    value: 'color',
    custom: true
  },
  {
    text: 'Empresa',
    align: 'start',
    sortable: true,
    value: 'companyName',
  },
  {
    text: 'Favorito',
    align: 'center',
    sortable: true,
    value: 'isFavorite',
    custom: true
  },
  {
    text: 'Ações',
    value: 'actions',
    align: 'right',
    sortable: false
  }

]
